module.exports = __webpack_public_path__ + "static/media/copyIcon2.2a9be5de.svg";